import React from "react";

import { Props } from "./types";

function ArrowIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 10 6.5">
      <path d="M4.462.645a.7.7,0,0,1,1.076,0L9.043,4.852A.7.7,0,0,1,8.505,6H1.495A.7.7,0,0,1,.957,4.852Z" />
    </svg>
  );
}

export { ArrowIcon };
